import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IconBadge } from '@/components/atoms';
import { type ContentItem } from '@/content/site';

export function IconFeature({ item, inverse }: { item: ContentItem; inverse?: boolean }) {
  return (
    <Stack direction="row" spacing={4} alignItems="flex-start">
      <IconBadge name={item.icon} tone={inverse ? 'inverse' : 'surface'} />
      <Box sx={{ pt: 1 }}>
        <Typography variant="h6" component="h3">
          {item.title}
        </Typography>
        {item.text && (
          <Typography
            variant="body2"
            sx={{ mt: 1, color: inverse ? 'rgba(255,255,255,0.72)' : 'text.secondary' }}
          >
            {item.text}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
